<template>
  <a-modal :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['id', validatorRules.id]"></a-input>
        </a-form-item>
        <a-form-item v-show="show" label="预览" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a target="_blank" v-bind:href="link">厨房痛点-客户案例详情页预览
          </a>
        </a-form-item>
        <a-form-item label="风格" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" ref="fdStyle" v-decorator="['fdStyle', validatorRules.fdStyle]"
            :trigger-change="true" dictCode="customer_case_style" placeholder="请选择风格" />
        </a-form-item>
        <a-form-item label="户型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" ref="fdHouseType" v-decorator="['fdHouseType', validatorRules.fdHouseType]"
            :trigger-change="true" @change="setCltnameTitle1" dictCode="customer_case_house_type" placeholder="请选择户型" />
        </a-form-item>
        <a-form-item label="系列" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" ref="series" v-decorator="['series', validatorRules.series]" @add="loadData2"
            :trigger-change="true" placeholder="请选择系列" />
        </a-form-item>
        <a-form-item label="套路" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" ref="routine" @change="setCltnameTitle2"
            v-decorator="['routine', validatorRules.routine]" :trigger-change="true" placeholder="请选择套路" />
        </a-form-item>
        <a-form-item label="方案名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['cltnameTitle', validatorRules.cltnameTitle]" placeholder="请输入方案名称"></a-input>
        </a-form-item>
        <a-form-item label="主图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['jpgaddress01', validatorRules.jpgaddress01]" :trigger-change="true"
            :uploadData="uploadData1" :beforeUpload="beforeUpload"></j-upload>
        </a-form-item>
        <a-form-item label="详情图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['jpgdetailaddress', validatorRules.jpgdetailaddress]" :trigger-change="true"
            :uploadData="uploadData2" :beforeUpload="beforeUpload"></j-upload>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import pick from 'lodash.pick'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from './JUpload'
  import JDictSelectTag from './JDictSelectTag'

  export default {
    name: 'CustomerCaseModal',
    components: {
      JUpload,
      JDictSelectTag,
    },
    data() {
      return {
        show: false,
        form: this.$form.createForm(this),
        title: '操作',
        width: 800,
        visible: false,
        link: "",
        model: {},
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        confirmLoading: false,
        validatorRules: {
          fdStyle: {
            rules: [{
              required: true,
              message: '请输入风格!'
            }]
          },
          fdHouseType: {
            rules: [{
              required: true,
              message: '请输入户型!'
            }]
          },
          series: {
            rules: [{
              required: true,
              message: '请输入系列!'
            }]
          },
          routine: {
            rules: [{
              required: true,
              message: '请输入套路!'
            }]
          },
          cltnameTitle: {
            rules: [{
              required: true,
              message: '请输入方案名称!'
            }]
          },
          jpgaddress01: {
            rules: [{
              required: true,
              message: '请输入主图路径!'
            }]
          },
          jpgdetailaddress: {
            rules: [{
              required: true,
              message: '请输入详情图路径!'
            }]
          },
        },
        url: {
          add: '/customercase.base/customerCase/add',
          edit: '/customercase.base/customerCase/edit',
          get: '/customercase.base/customerCase/getSerialRoutine',
        },
      }
    },
    created() {},
    methods: {
      add() {
        this.show = false;
        this.form.resetFields()
        this.model = Object.assign({}, {})
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'cltnameTitle',
              'cnSeriesname',
              'series',
              'cnRoutnename',
              'routine',
              'fdStyle',
              'fdHouseType',
              'jpgaddress01',
              'jpgdetailaddress'
            )
          )
        })
        this.loadData()
      },
      edit(record) {
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.show = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'id',
              'cltnameTitle',
              'cnSeriesname',
              'series',
              'cnRoutnename',
              'routine',
              'fdStyle',
              'fdHouseType',
              'jpgaddress01',
              'jpgdetailaddress'
            )
          )
        })
        this.link = "https://gis.canc.com.cn:9444/gallery-kitchen/?j_lang=zh-CN#/detail?id=" + this.model.id;
        this.loadData()
      },
      setCltnameTitle1() {
        this.form.resetFields(['cltnameTitle'])
        setTimeout(() => {
          this.$nextTick(() => {
            let type = this.form.getFieldValue('fdHouseType')
            let routine = this.$refs.routine.getSelectLabels();
            this.model.cltnameTitle = routine + type;
            this.form.setFieldsValue(
              pick(
                this.model,
                'cltnameTitle'
              )
            )
          })
        }, 1000)
      },
      setCltnameTitle2(val) {
        this.form.resetFields(['cltnameTitle'])
        setTimeout(() => {
          this.$nextTick(() => {
            let type = this.form.getFieldValue('fdHouseType')
            let routine = this.$refs.routine.getSelectLabels();
            this.model.cltnameTitle = routine + type;
            this.form.setFieldsValue(
              pick(
                this.model,
                'cltnameTitle'
              )
            )
          })
        }, 1000)

      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'post'
            }
            let formData = Object.assign(this.model, values)
            console.log('表单提交数据', formData)
            httpAction(httpurl, formData, method)
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
                that.close()
              })
          }
        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(
          pick(
            row,
            'cltnameTitle',
            'cnSeriesname',
            'series',
            'cnRoutnename',
            'routine',
            'fdStyle',
            'fdHouseType',
            'jpgaddress01',
            'jpgdetailaddress'
          )
        )
      },
      uploadData1() {
        let filepathData = 'customercase/' + this.$refs.fdStyle.getSelectLabels()
        if (this.$refs.series.getSelectLabels()) {
          filepathData = filepathData + '/' + this.$refs.series.getSelectLabels()
          if (this.$refs.fdHouseType.getSelectLabels()) {
            filepathData = filepathData + '/' + this.$refs.fdHouseType.getSelectLabels()
            if (this.$refs.routine.getSelectLabels()) {
              filepathData = filepathData + '/' + this.$refs.routine.getSelectLabels()
            }
          }
        }
        return {
          filePath: filepathData
        }
      },
      uploadData2() {
        let filepathData = 'customercasedetail/' + this.$refs.fdStyle.getSelectLabels()
        if (this.$refs.series.getSelectLabels()) {
          filepathData = filepathData + '/' + this.$refs.series.getSelectLabels()
          if (this.$refs.fdHouseType.getSelectLabels()) {
            filepathData = filepathData + '/' + this.$refs.fdHouseType.getSelectLabels()
            if (this.$refs.routine.getSelectLabels()) {
              filepathData = filepathData + '/' + this.$refs.routine.getSelectLabels()
            }
          }
        }
        return {
          filePath: filepathData
        }
      },
      beforeUpload(file, fileList) {
        let values1 = this.form.getFieldsValue(['fdStyle'])
        let values2 = this.form.getFieldsValue(['fdHouseType'])
        let values3 = this.form.getFieldsValue(['series'])
        let values4 = this.form.getFieldsValue(['routine'])
        if (!values1.fdStyle) {
          this.$message.warning('请先选择风格')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        if (!values2.fdHouseType) {
          this.$message.warning('请先选择户型')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        if (!values3.series) {
          this.$message.warning('请先选择系列')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        if (!values4.routine) {
          this.$message.warning('请先选择套路')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        var fileType = file.type
        if (fileType === 'image') {
          if (fileType.indexOf('image') < 0) {
            this.$message.warning('请上传图片')
            return false
          }
        } else if (fileType === 'file') {
          if (fileType.indexOf('image') >= 0) {
            this.$message.warning('请上传文件')
            return false
          }
        }
        //TODO 扩展功能验证文件大小
        return true
      },
      loadData() {
        let series = this.form.getFieldValue('series')
        let routine = this.form.getFieldValue('routine')
        let httpurl = this.url.get
        let param = {
          series: '',
          routine: ''
        }
        let optionsData = []
        getAction(httpurl, param).then((res) => {
          let data = res.result
          if (data != undefined) {
            for (var i = 0; i < data.length; i++) {
              let dataobj = {
                text: data[i].cnSeriesname,
                value: data[i].series,
              }
              optionsData.push(dataobj)

            }
            this.loadData1()
            this.$refs.series.setCurrentDictOptions(optionsData)
          }
        })
      },
      loadData1(val) {
        let series = this.form.getFieldValue('series')
        let routine = this.form.getFieldValue('routine')
        let httpurl = this.url.get
        let param = {
          series,
          routine: ''
        }
        let optionsData = []
        getAction(httpurl, param).then((res) => {
          let data = res.result
          if (data != undefined) {
            for (var i = 0; i < data.length; i++) {
              let dataobj = {
                text: data[i].cnRoutnename,
                value: data[i].routine,
              }
              optionsData.push(dataobj)
            }
            this.$nextTick(() => {
              this.$refs.routine.setCurrentDictOptions(optionsData)
            });

          }
        })
      },
      loadData2(val) {
        this.form.resetFields(['routine'])
        let series = this.form.getFieldValue('series')
        let routine = this.form.getFieldValue('routine')
        let httpurl = this.url.get
        let param = {
          series,
          routine: ''
        }
        let optionsData = []
        getAction(httpurl, param).then((res) => {
          let data = res.result
          if (data != undefined) {
            for (var i = 0; i < data.length; i++) {
              let dataobj = {
                text: data[i].cnRoutnename,
                value: data[i].routine,
              }
              optionsData.push(dataobj)
            }
            this.$refs.routine.setCurrentDictOptions(optionsData)
          }
        })
      },
    },
  }
</script>